import React, {useMemo} from "react";
import { moduleContent } from "./moduleContent";
import { HubPathRouting } from "../../HubFramework/pathBuilder";
import { HubFramework } from "../../HubFramework";
import { IdmsDataContext } from "./idmsDataContext";

export const Module: React.FC = () => {
    HubPathRouting.setProject();
    HubPathRouting.setModule();

    const moduleContext = useMemo(() => ({}), [])

    return (
        <IdmsDataContext.Provider value={moduleContext}>
            <HubFramework hubContent={moduleContent} module={moduleContext} />
        </IdmsDataContext.Provider>
    );
};
